import React, { useState } from 'react';
import { exportReportableEvents } from '../../../api/v2/reportable_events';
import { successToast } from '../../ui_kit/utilities/success_toast';

import styles from './export_button.module.css';

const download = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

// Exports whatever is on screen rather than the whole dataset, so the same filters and sort are
// sent to the server that produced the list.
export default function ExportButton({ filters, disabled }) {
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState(null);

  const runExport = () => {
    setExporting(true);
    setError(null);

    exportReportableEvents(filters)
      .then(({ blob, filename }) => {
        download(blob, filename);
        successToast(`${filename} has been downloaded.`);
      })
      .catch(() => setError('We could not produce the export. Try again.'))
      .finally(() => setExporting(false));
  };

  return (
    <div className={styles.wrapper}>
      <button className={styles.button} disabled={disabled || exporting} onClick={runExport} type='button'>
        <svg aria-hidden='true' className={styles.icon} viewBox='0 0 16 16'>
          <path
            d='M8 2V10M8 10L5 7M8 10L11 7M3 12.5H13'
            fill='none'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='1.5'
          />
        </svg>
        {exporting ? 'Exporting…' : 'Export page'}
      </button>

      {error && (
        <p className={styles.error} role='alert'>
          {error}
        </p>
      )}
    </div>
  );
}
